module.exports = __webpack_public_path__ + "molby_square-c23f36018c919cae9d6a21a99826252b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/dk/molby_square.jpg
// module id = 1166
// module chunks = 1 2